import React, { useCallback } from "react";
import { OrgButton } from "../OrgButton";
import { RoutineEditParams } from "../../RoutineAdmin/RoutineEditMain/RoutineEditNavigation";
import { useWorkspaceId } from "../workspaceId";
import { useMutation, graphql } from "react-relay";
import { useIntlTokens } from "@/src/components/mobile/useIntlTokens";
import { WorkspaceRoutineTemplateCreateButtonMutation } from "./__generated__/WorkspaceRoutineTemplateCreateButtonMutation.graphql";

export function WorkspaceRoutineTemplateCreateButton(props: {
  openRoutineEdit: (params: RoutineEditParams) => void;
}) {
  const intl_tokens = useIntlTokens();
  const workspaceId = useWorkspaceId();
  const [createRoutineMutation] =
    useMutation<WorkspaceRoutineTemplateCreateButtonMutation>(graphql`
      mutation WorkspaceRoutineTemplateCreateButtonMutation($workspaceId: ID!) {
        workspace(id: $workspaceId) {
          createRoutine(type: TEMPLATE) {
            id
          }
        }
      }
    `);

  const createRoutine = useCallback(() => {
    createRoutineMutation({
      variables: {
        workspaceId,
      },
      onError(error) {
        console.log(JSON.stringify(error, null, 2));
      },
      onCompleted(response, errors) {
        if (!response.workspace.createRoutine) {
          return;
        }
        props.openRoutineEdit({
          orgWorkspaceId: workspaceId,
          id: response.workspace.createRoutine.id,
          mode: "CREATE",
        });
      },
    });
  }, [createRoutineMutation, props, workspaceId]);

  return (
    <OrgButton
      backgroundColor="primary"
      icon="add"
      tintColor="text-inverted"
      title={intl_tokens.Add}
      onPress={() => {
        createRoutine();
      }}
    />
  );
}
